import {
  Outlet,
  Link,
  useLoaderData,
  NavLink
} from "react-router-dom";
import * as API from "../services/especialistas";
import Select from "react-select";

import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import es from 'react-phone-input-2/lang/es.json'

export async function loader({ params }) {
  const token = sessionStorage.getItem("token");

  // Si no hay token, simplemente NO llamamos a la API y retornamos null
  if (!token) {
    return null;
  }
  return API.getEspecialistaByID(params.especialistaId);
}


export function EspecialistaAdminItem() {
  const especialista = useLoaderData();
  console.log(especialista);

  const firstName = especialista?.first_name;
  const lastName = especialista?.last_name;
  const email = especialista?.email;
  const telefono = especialista?.meta?.telefono;
  const direccion = especialista?.meta?.direccion;
  const direccionNum = especialista?.meta?.direccion_num;
  const direccionPiso = especialista?.meta?.direccion_piso;
  const direccionCiudad = especialista?.meta?.direccion_ciudad;
  const direccionProvincia = especialista?.meta?.direccion_provincia;
  const direccionCp = especialista?.meta?.direccion_cp;
  const dni = especialista?.meta?.dni;
  const username = especialista?.username;
  const especialidad = especialista?.meta?.especialidad;
  const colegiado = especialista?.meta?.colegiado;
  const telefonoSecundario = especialista?.meta?.telefono_familiar;
  const estadoUsuario = especialista?.meta?.estado || 'activo';

  return (
    <>
      <div id='content'>
        <form id='formNewElement'>
        <fieldset id="disabledContainer" disabled="disabled">
        <h3>Ficha del Especialista</h3>
          <div className='grid--2col'>
            <div className='field'>
              <label htmlFor='firstName'>Nombre</label>
              <div className='control'>
                <input
                  className='input'
                  id='firstName'
                  readOnly
                  type='text'
                  value={firstName}
                />
              </div>
            </div>
            <div className='field'>
              <label htmlFor='lastName'>Apellidos</label>
              <div className='control'>
                <input
                  className='input'
                  id='lastName'
                  readOnly
                  type='text'
                  value={lastName}
                />
              </div>
            </div>
          </div>
          
          <div className='grid--2col'>
            <div className='field'>
              <label htmlFor='email'>Email</label>
              <div className='control'>
                <input
                  className='input'
                  id='email'
                  readOnly
                  type='email'
                  value={email}
                />
              </div>
            </div>
            <div className='field'>
              <label htmlFor='dni'>DNI</label>
              <div className='control'>
                <input
                  className='input'
                  id='dni'
                  readOnly
                  type='text'
                  value={dni}
                />
              </div>
            </div>
          </div>

          <div className='grid--2col'>
            <div className='field'>
              <label htmlFor='telefono'>Teléfono Móvil</label>
              <div className='control'>
                <PhoneInput
                  inputProps={{
                    className: 'input',
                    name: 'telefono',
                    required: true,
                    id: 'telefono',
                    readOnly: true
                  }}
                  disabled
                  placeholder='+34 658 309 174'
                  localization={es}
                  value={telefono}
                  country={'es'}
                />
              </div>
            </div>
            <div className='field'>
                  <label htmlFor='telefonoSecundario'>
                    Número de teléfono secundario
                  </label>
                  <div className='control'>
                    <PhoneInput
                      inputProps={{
                        className: "input",
                        name: "telefonoSecundario",
                        required: true,
                        id: "telefonoSecundario",
                        readOnly: true,
                      }}
                      disabled
                      placeholder='+34 658 309 174'
                      localization={es}
                      value={telefonoSecundario}
                      country={"es"}
                    />
                  </div>
            </div>
          </div>

          <div className='grid--2col'>
              <div className='field'>
                <label htmlFor='direccion'>Dirección</label>
                <div className='control'>
                  <input
                    className='input'
                    id='direccion'
                    readOnly
                    type='text'
                    value={direccion}
                  />
                </div>
              </div>
              <div className='field'>
                <label htmlFor='direccionNum'>Número</label>
                <div className='control'>
                  <input
                    className='input'
                    id='direccionNum'
                    readOnly
                    type='text'
                    value={direccionNum}
                  />
                </div>
              </div>
              <div className='field'>
                <label htmlFor='direccionPiso'>Piso</label>
                <div className='control'>
                  <input
                    className='input'
                    id='direccionPiso'
                    readOnly
                    type='text'
                    value={direccionPiso}
                  />
                </div>
              </div>

              <div className='field'>
                <label htmlFor='direccionCiudad'>Población</label>
                <div className='control'>
                  <input
                    className='input'
                    id='direccionCiudad'
                    readOnly
                    type='text'
                    value={direccionCiudad}
                  />
                </div>
              </div>
              <div className='field'>
                <label htmlFor='direccionProvincia'>Provincia</label>
                <div className='control'>
                  <input
                    className='input'
                    id='direccionProvincia'
                    readOnly
                    type='text'
                    value={direccionProvincia}
                  />
                </div>
              </div>
              <div className='field'>
                <label htmlFor='direccionCp'>Código postal</label>
                <div className='control'>
                  <input
                    className='input'
                    id='direccionCp'
                    readOnly
                    type='text'
                    value={direccionCp}
                  />
                </div>
              </div>
            </div>

          
          <div className='grid--2col'>
            <div className='field'>
              <label htmlFor='username'>Nombre de usuario</label>
              <div className='control'>
                <input
                  className='input'
                  id='username'
                  readOnly
                  type='text'
                  value={username}
                />
              </div>
            </div>
          </div>

          <div className='grid--2col'>
            <div className='field'>
              <label htmlFor='especialidad'>Especialidad</label>
              <div className='control'>
              <Select
                          isMulti
                          id='especialidad'
                          name='especialidad'
                          className='basic-multi-select'
                          classNamePrefix='select'
                          placeholder='Seleccionar especialidad'
                          value={especialidad}
                    readOnly
                    isDisabled
                        />
              </div>
            </div>
            <div className='field'>
              <label htmlFor='colegiado'>Número de Colegiado</label>
              <div className='control'>
                <input
                  className='input'
                  id='colegiado'
                  readOnly
                  type='text'
                  value={colegiado}
                />
              </div>
            </div>
          </div>

          <div className='grid--2col'>
            <div className="field">
              <label htmlFor="estadoUsuario">Estado del usuario</label>
              <div className="control">
                <div className="select">
                  <select
                    className="select"
                    id="estadoUsuario"
                    readOnly
                    name="estadoUsuario"
                    value={estadoUsuario}
                  >
                    <option disabled value="">-- Selecciona una opción --</option>
                    <option value="activo">Activo</option>
                    <option value="inactivo">Inactivo</option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          </fieldset>
        </form>
      </div>
      <div id="actions">
        <Link className="button is-link" to={`edit`}>Editar</Link>
      </div>
    </>
  );
}
